import { render, staticRenderFns } from "./UserInfoPrivacy.vue?vue&type=template&id=01d4f304&scoped=true"
import script from "./UserInfoPrivacy.vue?vue&type=script&lang=js"
export * from "./UserInfoPrivacy.vue?vue&type=script&lang=js"
import style0 from "./UserInfoPrivacy.vue?vue&type=style&index=0&id=01d4f304&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d4f304",
  null
  
)

export default component.exports